<template>  
    <section>
        <componet :is="stamp" v-if="ISSHOW"></componet>
		<div class="tabs">
			<span :class='peg==1?"home-select":"home"' 	@click='change(1)'>下单</span>
			<span :class='peg==4?"member-select":"member"' 	@click='change(4)'>充值</span>
			<span :class='peg==2?"order-select":"order"' @click='change(2)' >订单</span>
			<span :class='peg==3?"person-select":"person"' @click='change(3)'>我的</span>
		</div>
    </section>
</template>

<script>
    import CommonHeader from '@/components/CommonHeader'
	import PlaceOrder from '@/components/PlaceOrder'
	import Order from '@/components/MyOrder'
	import Person from '@/components/Personal'
    import Member from '@/components/Recharge'
    import {UpMinOpenid} from '@/api/common';
    import wx from "weixin-js-sdk";
    import utils from '@/assets/jslibs/utils'
    import {mapMutations} from "vuex";
    export default {
        name: 'index',
		data(){
			return{
				peg:sessionStorage.getItem("peg")|| 1,
				stamp:sessionStorage.getItem("stamp") || "placeOrder",
        ISSHOW:false,
        previous_page:'',
			}
		},
      created(){

          //this.MinWechatLogin();
        //console.log(4321);
      },
		beforeCreate(){
          //console.log(utils.isWxMin());

			if(sessionStorage.getItem("backUrl")){
				var url = sessionStorage.getItem("backUrl");
				if(sessionStorage.getItem("chargeUrl")){
					var chargeUrl = sessionStorage.getItem("chargeUrl");
					location.href = url+"?"+chargeUrl;
				}else{
					location.href = url;
				}

                sessionStorage.removeItem("backUrl");
				sessionStorage.removeItem("chargeUrl");
			}
            
            //清除用户下单时的信息回填，用户填写信息只在用户下单时存在
            sessionStorage.removeItem("params");
            sessionStorage.removeItem("newOrder");

    },

        mounted(){

            document.title = "用心淘下单平台";
			window.scrollTo(0,0);
          this.MinWechatLogin();
        },
        components: {
            CommonHeader,
			Order,
			PlaceOrder,
			Person,
			Member
        },
        
        methods:{
          ...mapMutations(['update_expiry_time']),
            change(type){
                if(type==1){
                    this.peg = 1;
                    this.stamp = "placeOrder";
                    sessionStorage.setItem("peg",1);
                    sessionStorage.setItem("stamp","placeOrder");
                }else if(type==2){
                    this.peg = 2;
                    this.stamp = "order";
                    sessionStorage.setItem("peg",2);
                    sessionStorage.setItem("stamp","order");
                }else if(type==3){
                    this.peg = 3;
                    this.stamp = "person";
                    sessionStorage.setItem("peg",3);
                    sessionStorage.setItem("stamp","person");
                }else if(type==4){
                    this.peg = 4;
                    this.stamp = "member";
                    sessionStorage.setItem("peg",4);
                    sessionStorage.setItem("stamp","member");
                }
            },

          async MinWechatLogin(){
            if (this.previous_page === 1){
              if (utils.getSession('WxUserInfo') && !utils.getCookie('X-Access-Token')){
                //防止用户返回 必须要用户去绑定手机号
                this.$router.push('./bind-mobile');
                return;
              }
            }
            var user = this.$route.query.code;
            if (user){
              localStorage.setItem('min_code',user);
            }


            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
              //微信环境下
              wx.miniProgram.getEnv((res) =>{
                if (res.miniprogram) {
                  // 小程序环境下逻辑
                  if (!user){
                    user = localStorage.getItem('min_code');

                    if (!user){
                      //微信小程序登录
                      this.ISSHOW = true;
                    }
                  }
                  this.sendMinOpenId(user);
                } else {
                  //console.log("微信浏览器里面")
                  //非小程序环境下逻辑
                  this.ISSHOW = true;
                }
              });
            }else {
              this.ISSHOW = true;
            }

          },
          async MinWechatLogin2(){
            var user = this.$route.query.code;
            if (user){
              localStorage.setItem('min_code',user);
            }
            var _this = this;
            var min_openid =  localStorage.getItem('min_openid');
            wx.miniProgram.getEnv(function (res) {
              if (res.miniprogram && !min_openid) {
                if (!user){
                  user = localStorage.getItem('min_code');
                  if (!user){
                    window.toast("code不存在","txt");
                    return;
                  }
                }

                _this.sendMinOpenId(user);
              }
            });
          },
          //记录微信小程序的openid 方便小程序支付
          async sendMinOpenId2(code){

            //多一步判断用户有无登录

              var _data ={
                code:code
              }
              const { data, status } = await UpMinOpenid(_data);

              if (status==200){
                var min_open_id = data.min_open_id;
                localStorage.setItem('min_openid',min_open_id);
              }else {
                window.toast("小程序信息获取失败","txt");
              }
            },

          async sendMinOpenId(code){
            if (utils.getCookie('X-Access-Token')){
              this.ISSHOW = true;
              return;
            }
            var _data ={
              code:code
            }

            const { data, status } = await UpMinOpenid(_data);
            if (status==200){
              if (data.bind_account == true){
                //去绑定手机号
                utils.setSession('WxUserInfo',data.wxUserInfo);
                this.$router.push('./bind-mobile');
              }else if(data.bind_account == false){
                //直接登录
                sessionStorage.removeItem("peg");         //用户重新登录的时候，清除用户端展示模块的标示 登录后默认展示首页
                sessionStorage.removeItem("stamp");
                sessionStorage.removeItem("mark");
                sessionStorage.removeItem("sign");
                utils.setCookie('X-Access-Token', data.user_access_token.token, 7);
                this.update_expiry_time(data.user_access_token.expiry_time);
                this.$router.push('./index')
                this.ISSHOW = true;
              }
            }else {
              //window.toast("小程序信息获取失败","txt");
            }
          }
        },

      beforeRouteEnter(to, from, next){
        next((vm) => {
          //判断是从这个路由页面返回的，值就改变
          if (from.path == '/bind-mobile') {
            vm.previous_page = 1;
            //alert(from.path);
          }
        })
      },
        
    }
</script>

<style lang='less' scoped>
	@import '~@/assets/styles/variable.less';
	@import '~@/assets/styles/handleMethods.less';
	@import '~@/assets/styles/reset.css';
    section{font-family:PingFangSC-Regular;;font-weight:400;-webkit-overflow-scrolling: touch;}
	body{max-width: 1080px;min-width: 320px;max-width: 540px;margin: 0 auto;}
    .list{overflow-y: scroll; width: 100%;height: 100%;}
	.tabs{height: 50px;border: 1px solid #EDEDED;padding-top:2px;position: fixed;bottom: 0;left: 0;right: 0;z-index: 2;padding-left:40px;padding-right:40px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center;background: #fff}
	.tabs span{font-size: 12px;padding-top:22px;text-align: center;}
    .home{color:rgba(51,51,51,1);background:url(../assets/images/home/ic_home_home_formal_new.png) no-repeat center top;background-size: 22px}
	.order{color:rgba(51,51,51,1);background:url(../assets/images/home/ic_home_order_form.png) no-repeat center top;background-size: 22px}
	.person{color:rgba(51,51,51,1);background:url(../assets/images/home/ic_home_mine_formal.png) no-repeat center top;background-size: 22px}
	.member{color:rgba(51,51,51,1);background:url(../assets/images/home/ic_tab_vip_normal.png) no-repeat center top;background-size: 22px}
	.home-select{color: #4184F4;background:url(../assets/images/home/ic_home_home_liguht_new.png) no-repeat center top;background-size: 22px}
	.order-select{color: #4184F4;background:url(../assets/images/home/ic_home_order_light.png) no-repeat center top;background-size: 22px}
	.person-select{color: #4184F4;background:url(../assets/images/home/ic_home_mine_light.png) no-repeat center top;background-size: 22px}
	.member-select{color: #4184F4;background:url(../assets/images/home/ic_tab_vip_light.png) no-repeat center top;background-size: 22px}


</style>
